import { getItemsPerPageOptions } from '../../../utils';
import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  BodyText,
  Pagination,
  Select,
  Table,
} from '@chargify/custom-ui-components';
import { useDeviceInfo } from '@chargify/device-provider';

import { SelectWrapper } from '../InvoicesTable.styles';
import { PaginationWrapper } from './PagesPagination.styles';

export interface PagesPaginationProps {
  page: number;
  totalPages: number;
  itemsPerPage: number;
  totalInvoices: number;
  onItemsPerPageChange: (itemsPerPage: number) => void;
  onPageChange: (page: number) => void;
}
export const PagesPagination = ({
  page,
  totalPages,
  onPageChange,
  onItemsPerPageChange,
  totalInvoices,
  itemsPerPage,
}: PagesPaginationProps) => {
  const { t } = useTranslation('billing-history');
  const { device } = useDeviceInfo();
  const isMobile = device === 'mobile';

  return (
    <Table.Footer
      justifyContent={isMobile ? 'center' : 'space-between'}
      paddingY={5}
      paddingX={7}
      gridGap={5}
    >
      <BodyText color={'gray.main'} variant={'body2'}>
        {t('invoice', { count: totalInvoices })}
      </BodyText>
      <PaginationWrapper isMobile={device === 'mobile'}>
        <Pagination
          page={page}
          onChange={onPageChange}
          totalPages={totalPages}
        />
      </PaginationWrapper>
      <SelectWrapper>
        <Select
          options={getItemsPerPageOptions(t)}
          selectedValue={itemsPerPage}
          variant="secondary"
          dropdownVariant="secondary"
          onSelect={(selectedItem) => {
            onItemsPerPageChange(Number(selectedItem.value));
          }}
          selectSize="small"
        />
      </SelectWrapper>
    </Table.Footer>
  );
};
